import * as React from 'react';
import { FIELD_TYPE, withSimpleForm } from 'app/infrastructure/simple-form';
import { endpoint, importTranslations, form } from 'app/area/import/constants';
import { SerializeType, SimpleFormProps } from 'app/infrastructure/simple-form/types';
import { STATE } from 'app/constants';
import { simpleFieldForPath } from 'app/infrastructure/simple-form/';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { defaultSerializeMappings } from 'app/infrastructure/simple-form/serialize';
import { requiredValidation } from 'app/infrastructure/simple-form/validation/rules';
import { SimpleFormValidationConfig } from 'app/infrastructure/simple-form/validation/types';
import styles from './import-view.scss';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { FileSelector } from 'ui';

export interface ImportAddCaseComponentProps {
  fetching: boolean;
  onClose: () => void;
  onDone: (formData: any, file: File, onClose: () => any) => void;
}

export interface ImportAddCaseState {
  file: File;
}

const SimpleForm = simpleFieldForPath(STATE.import);

export type ImportAddCaseContainerProps = ImportAddCaseComponentProps & DefaultContainerProps & SimpleFormProps;
export class ImportAddCaseComponent extends React.Component<ImportAddCaseContainerProps, ImportAddCaseState> {

  public static statePath: string = STATE.import;

  public state: Readonly<ImportAddCaseState> = {
    file: undefined
  };

  private validationConfig: SimpleFormValidationConfig = [
    requiredValidation(form.importset)
  ];

  private onSubmit = () => {
    const { validate, serialize, onDone, onClose, translation } = this.props;

    validate(this.validationConfig,
      () => onDone(serialize(defaultSerializeMappings), this.state.file, onClose),
      translation.validation_error);
  };

  private handleChangeFileUploader = (file:File) => {
    this.setState({ file });
  };

  public render() {
    const {fetching, translation, onClose, formValues } = this.props;
    const disabled = !formValues.importset || !this.state.file || fetching;

    return (
      <ModalWrapper
        headerTitle={translation.import_file_to_synergi_life}
        btnTitle={translation.import_submit}
        btnCancelTitle={translation.import_cancel}
        onDone={this.onSubmit}
        closeOnDone={false}
        onClose={onClose}
        largeSize={false}
        isDisabled={disabled}
        isCancelDisabled={disabled}>
          <SimpleForm
            name={form.importset}
            type={FIELD_TYPE.SELECT_SINGLE_HIERARCHY}
            optionsEndpoint={endpoint.loadImportSetOptions}
            label={{ text: translation.import_set, required: true }}
            initialValue={undefined}
            translation={translation}
            placeholder={translation.import_search_placeholder}
            serialize={{ type: SerializeType.V_VALUE }}
            readOnly={fetching} />

          <div className="control-label">
            <span className="asterisk-required">* </span>{translation.import_choose_file}
          </div>

          <div className={`input-wrapper ${styles.importFileWrapper}`}>
            <FileSelector
              textSelectFile={translation.import_choose_file}
              onSelected={this.handleChangeFileUploader}
              disabled={fetching}
            />
          </div>
          <br />

          <SimpleForm
            name={form.comments}
            type={FIELD_TYPE.TEXTAREA}
            label={{ text: translation.import_file_description }}
            initialValue={''}
            translation={translation}
            maxLength={254}
            serialize={{ type: SerializeType.PRIMITIVE_VALUE }}
            readOnly={fetching} />
      </ModalWrapper>
    );
  }
}

const container = containerFactory<ImportAddCaseComponentProps>(withSimpleForm(ImportAddCaseComponent), {}, undefined, importTranslations);
export { container as ImportAddCase };
